module.exports = __webpack_public_path__ + "static/media/login.02d0b965.jpg";